import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  cancelCrashBetService, escapeCrashBetService, getAllRoundHistoryService,
  getMyBetsService, verifyProvableFairCrashService, getTopBetsService, placeBetCrashGameService, getPreviousRoundBetsService
} from 'network/services/thunderStrikeGame.service'
import { appendCurrentBetsToMyBets, setCurrentPlacedBet, setPlacedCrashBetId, setPlacingOrCashoutLoading } from 'redux-store/redux/slices/thunderStrikeGame.slice'
import { openErrorToaster } from 'utils/common-services/toaster.service'
// import { openSuccessToaster } from 'utils/common-services/toaster.service'
import { APPEND_TYPES } from 'utils/constants/index'

export const placedBetCrashGame = createAsyncThunk('power-of-thor-game/place-bet-crash-game', async ({ payload, id, onSuccess }, thunkApi) => {
  try {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: true }))
    const res = await placeBetCrashGameService(payload)
    onSuccess()
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: res.id, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: res, reset: false }))
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return res
  } catch (error) {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const escapeCrashBet = createAsyncThunk('power-of-thor-game/player-escape-crashGame', async ({ betId, id, onSuccess }, thunkApi) => {
  try {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: true }))
    const res = await escapeCrashBetService({ betId })
    onSuccess()
    // const store = thunkApi.getState()
    // if (store?.crashGame?.myBetsData) {
    //   const state = store?.crashGame
    //   const escapedBet = [res]
    //   const betExist = state?.myBetsData?.crashGameBets?.some(bet => bet?.id === escapedBet?.[0]?.id)
    //   if (!betExist) {
    //     openSuccessToaster({ message: `You win Odds : ${res?.escapeRate} Coins :${res?.winningAmount.toFixed(2)}` })
    //   }
    // }
    thunkApi.dispatch(appendCurrentBetsToMyBets({ type: APPEND_TYPES.ESCAPE, data: [res] }))
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: null, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: null, reset: false }))
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return res
  } catch (error) {
    thunkApi.dispatch(setPlacingOrCashoutLoading({ index: id, value: false }))
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const cancelCrashBet = createAsyncThunk('power-of-thor-game/cancel-bet-crash-game', async ({ id, betId, onSuccess }, thunkApi) => {
  try {
    const res = await cancelCrashBetService({ betId })
    onSuccess()
    thunkApi.dispatch(setPlacedCrashBetId({ id, betId: null, reset: false }))
    thunkApi.dispatch(setCurrentPlacedBet({ id, betDetails: null, reset: false }))
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].name })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getAllRoundHistory = createAsyncThunk('power-of-thor-game/get-crash-game-history', async (_, thunkApi) => {
  try {
    const res = await getAllRoundHistoryService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBets = createAsyncThunk('power-of-thor-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBetsPaginated = createAsyncThunk('power-of-thor-game/myBets-paginated', async (params, thunkApi) => {
  try {
    const res = await getMyBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getPreviousRoundBets = createAsyncThunk('power-of-thor-game/previous-round-placed-bets', async (params, thunkApi) => {
  try {
    const res = await getPreviousRoundBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const verifyProvableFairCrash = createAsyncThunk('power-of-thor-game/check-provable-fair', async ({ payload }, thunkApi) => {
  try {
    const res = await verifyProvableFairCrashService(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
export const getTopBets = createAsyncThunk('power-of-thor-game/topBets', async (params, thunkApi) => {
  try {
    const res = await getTopBetsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
